var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.item === 1 || _vm.item === '1' || _vm.item === true)?_c('span',[_vm._v("Já")]):_c('span',[_vm._v("Nei")])])
}
var staticRenderFns = []

export { render, staticRenderFns }